<script>
import { Bar } from "vue-chartjs";
import { generateColorByString } from "@/services/chart-helper.js";

export default {
  name: "IkpMedParamValuesChart",
  extends: Bar,

  props: {
    name: {
      type: String,
      required: true,
    },

    items: {
      type: Array,
      required: true,
    },
  },

  data() {
    return {
      options: {
        maintainAspectRatio: false,
        responsive: true,
        scales: {
          yAxes: [
            {
              ticks: {
                beginAtZero: true,
              },
            },
          ],
        },
      },
    };
  },

  computed: {
    labels() {
      return this.items.map(item => item.date);
    },

    dataset() {
      return [
        {
          label: this.$props.name,
          backgroundColor: generateColorByString(this.$props.name),
          data: this.items.map(item => ({ x: item.date, y: item.value })),
        },
      ];
    },
  },

  watch: {
    items() {
      this.render();
    },
  },

  async mounted() {
    this.render();
  },

  methods: {
    render() {
      this.renderChart(
        {
          labels: this.labels,
          datasets: this.dataset,
        },
        this.options,
      );
    },
  },
};
</script>
